var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        { ref: "dataForm", attrs: { size: "small", "label-position": "top" } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("orderCenterCont.DownloadTemplate"),
                      },
                    },
                    [
                      _c("div", { ref: "download1" }, [
                        _c(
                          "span",
                          {
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.initDown()
                              },
                            },
                          },
                          [
                            _c("span", { staticStyle: { color: "#00A551" } }, [
                              _vm._v(
                                "补开cte发票模板(Preencher o modelo de factura CT-e).xlsx"
                              ),
                            ]),
                            _c("span", {
                              staticClass: "el-icon-download",
                              staticStyle: {
                                color: "#00A551",
                                "margin-left": "20px",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("basicData.UploadTheFile") } },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "demoUpload",
                          staticClass: "upload-demo",
                          attrs: {
                            "before-upload": _vm.beforeUpload,
                            "file-list": _vm.fileList,
                            "http-request": _vm.upLoad,
                            limit: 1,
                            "on-exceed": _vm.handleExceed,
                            "on-remove": _vm.handleRemove,
                            action: "",
                            drag: "",
                            multiple: "",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-plus",
                            staticStyle: { margin: "50px auto 20px" },
                          }),
                          _c("div", { staticClass: "el-upload__text" }, [
                            _vm._v(_vm._s(_vm.$t("orderImport.cldrUpload"))),
                          ]),
                          _c("div", { staticClass: "el-upload__text" }, [
                            _vm._v(
                              _vm._s(_vm.$t("basicData.PleaseUploadExcelFiles"))
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.ReopenCTeInvoiceResult"),
            visible: _vm.showBatchCancelResult,
            width: "600px",
            "show-close": false,
            "modal-append-to-body": true,
            "append-to-body": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showBatchCancelResult = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "20px 0" } },
            [
              _vm.percentage >= 100
                ? _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "margin-bottom": "20px" },
                    },
                    [
                      _c("div", { staticStyle: { flex: "1" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("organizationManage.all")) +
                            "：" +
                            _vm._s(_vm.excelJsonData.length)
                        ),
                      ]),
                      _c("div", { staticStyle: { flex: "1" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("organizationManage.succeed")) +
                            "：" +
                            _vm._s(_vm.successCount)
                        ),
                      ]),
                      _c("div", { staticStyle: { flex: "1" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("operationCenter.fail")) +
                            "：" +
                            _vm._s(_vm.failCount)
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c("el-progress", {
                attrs: {
                  "text-inside": true,
                  "text-color": "#fff",
                  "stroke-width": 26,
                  percentage: _vm.percentage,
                },
              }),
              _vm.percentage >= 100
                ? _c("div", { staticStyle: { "margin-top": "20px" } }, [
                    _c(
                      "div",
                      {
                        ref: "download1",
                        staticStyle: { "margin-bottom": "20px" },
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { "margin-bottom": "10px" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("mdfeTranslate.ReopenCTeInvoiceResult")
                              ) + "："
                            ),
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.downloadResult()
                              },
                            },
                          },
                          [
                            _c("span", { staticStyle: { color: "#00A551" } }, [
                              _vm._v(
                                "补开cte发票结果(Resultado da Reabertura da Fatura CT-e).xlsx"
                              ),
                            ]),
                            _c("span", {
                              staticClass: "el-icon-download",
                              staticStyle: {
                                color: "#00A551",
                                "margin-left": "20px",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm.percentage >= 100
            ? _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.confirmClose },
                    },
                    [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }